<template>
  <footer class="footer">
    <div class="footer-inner">
      <img src="../assets/svg/ecpat-logo.svg" class="logo" />
      <g-markdown class="footer-text" :content="footer.Text" />
    </div>
    <div class="sponsors" data-v-c3b844e2="">
      <img
        src="../assets/png/arvsfonden.png"
        alt="Arvsfonden"
        class="arvsfonden"
        data-v-c3b844e2=""
      />
    </div>
    <!-- <cookie-law
      ref="cookie"
      button-text="Ok!"
      :button-decline="true"
      theme="ecpat"

    >
      <div slot-scope="props" class="Cookie__content">
        <p>
          Dina personuppgifter är viktiga för oss! ECPAT Sverige använder
          cookies när du besöker någon av våra webbplatser. Med ditt samtycke
          använder vi cookies för att mäta och analysera användningen av
          webbplatsen (analytiska cookies).
          <br />
          <a
            href="https://www.ecpat.se/information-om-cookies"
            target="_blank"
            title="Om cookies"
          >
            Läs mer om cookies
          </a>
        </p>
        <g-button type="solid" color="green" @click.prevent="props.accept">
          Acceptera kakor
        </g-button>
      </div>
    </cookie-law> -->
  </footer>
</template>

<script>
import GET_FOOTER from '@/graphql/GetFooter.gql';

//import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    /*  CookieLaw */
  },
  apollo: {
    footer: {
      query: GET_FOOTER
    }
  },
  data() {
    return {
      footer: {
        Text: ''
      }
    };
  },
  methods: {
    // Om vill ge användaran ett val att slå av tracking.
    disableTracking: function() {
      //this.$ga.disable();
      this.$refs['cookie'].accept();
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: $green;

  background-size: 100%;
  color: #fff;
}

.footer-inner {
  margin: auto;
  max-width: $content-max-width;
  padding: 60px 20px 40px;
}

.sponsors {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.arvsfonden {
  margin: 1rem 0.5rem;
  flex: 1 1 180px;
  max-width: 180px;
}

.logo {
  display: block;
  margin: auto;
}

.footer-text {
  margin-left: auto;
  margin-right: auto;
  margin-top: 60px;
  max-width: $content-max-width;
}

.Cookie--ecpat {
  background-color: $black;
  padding: 20px;

  .Cookie__content {
    margin: auto;
    max-width: $content-max-width;

    p {
      margin: 0;
      margin-bottom: 20px;
    }

    a {
      color: $white;
      text-decoration: underline;
    }
  }
}

@media screen AND (min-width: $medium-screen) {
  .footer-inner {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: auto;
    max-width: $section-max-width;
    padding-top: 90px;

    .footer-text {
      margin: 0;
    }

    img {
      margin: 0;
      margin-right: 40px;
    }

    .sponsors {
      justify-content: flex-start;
      margin-top: 1rem;
    }
  }
}
</style>
